"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
const typestyle_1 = require("typestyle");
exports.Time = (0, typestyle_1.stylesheet)({
    time: {
        fontFamily: `'Roboto', Arial, Helvetica, sans-serif`,
        fontSize: '10pt'
    }
});
